export { default as Img200 } from './processed/200/Warrior.jpg';
export { default as Img400 } from './processed/400/Warrior.jpg';
export { default as Imgthumb } from './processed/thumb/Warrior.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Warrior.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Warrior.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      231,
      198,
      87
    ],
    "_population": 3201,
    "_hsl": [
      0.12847222222222224,
      0.7499999999999999,
      0.6235294117647059
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      210,
      92
    ],
    "_population": 886,
    "_hsl": [
      0.1293859649122807,
      0.873563218390805,
      0.6588235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      104,
      28,
      23
    ],
    "_population": 1701,
    "_hsl": [
      0.0102880658436214,
      0.6377952755905512,
      0.24901960784313726
    ]
  },
  "Muted": {
    "_rgb": [
      179,
      149,
      89
    ],
    "_population": 62,
    "_hsl": [
      0.11111111111111115,
      0.3719008264462809,
      0.5254901960784313
    ]
  },
  "DarkMuted": {
    "_rgb": [
      87,
      76,
      52
    ],
    "_population": 13,
    "_hsl": [
      0.11428571428571427,
      0.2517985611510791,
      0.27254901960784317
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Warrior.js